//codex-- Keep the toolbar redesign scoped to pages in this folder.
import PageToolbar, { ToolbarField } from './PageToolbar';
import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import axios from 'axios';
import SearchBarCP from '../components/SearchBarCP';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DateFormat from '../components/DateFormat';
import LoadingSpinner from '../components/LoadingSpinner';
import HeadingCp from '../components/HeadingCp';
import { clear } from '@testing-library/user-event/dist/clear';

const TechTimesheetReport = () => {
  const navigate = useNavigate();
  const [logs, setLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [selectedEmployee, setSelectedEmployee] = useState('');
  const [employees, setEmployees] = useState([]);
  const [overtime, setOvertime] = useState(0);
  const [regTime, setRegTime] = useState(0);
  const [jobNumber, setJobNumber] = useState('');
  const [jobDateFrom, setJobDateFrom] = useState('');
  const [jobDateTo, setJobDateTo] = useState('');

  const apiUrl = process.env.REACT_APP_API_URL;
  const api = `${apiUrl}/tech_crud.php`;

  useEffect(() => {
    fetchLogs();
    fetchEmployees();
  }, []);
  
  const fetchEmployees = async () => {
    try {
      const res = await axios.get(`${apiUrl}/service_crud.php?employee_list=true`);
      setEmployees(Array.isArray(res.data) ? res.data : []);
    } catch (error) {
      toast.error('Failed to load employees');
    }
  };

  const fetchLogs = async () => {
    try {
      const response = await axios.get(api, { params: { getList: 1 } });
      const data = Array.isArray(response.data[0]) ? response.data[0] : [];
      console.log(response.data);
      
      setLogs(data);
      setFilteredLogs(data);
      setRegTime(response.data[1] || 0);
      setOvertime(response.data[2] || 0);
    } catch (error) {
      toast.error('Error fetching timesheet logs', { position: 'top-center' });
    } finally {
      setLoading(false);
    }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    if (value === '') {
      setFilteredLogs(logs);
    } else {
      const filtered = logs.filter((item) =>
        item.address?.toLowerCase().includes(value.toLowerCase()) ||
        item.contractor?.toLowerCase().includes(value.toLowerCase()) ||
        item.notes?.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredLogs(filtered);
    }
  };

  const handleSearchClick = async () => {
    setLoading(true);
    try {
      const response = await axios.post(api, {
        status: 'search',
        data: { search: searchTerm }
      }, {
        headers: { 'Content-Type': 'application/json' }
      });
      const data = Array.isArray(response.data) ? response.data : [];
      setLogs(data);
      setFilteredLogs(data);
    } catch (error) {
      toast.error('Search failed', { position: 'top-center' });
    } finally {
      setLoading(false);
    }
  };

  const handleDateEmployeeFilter = async () => {
    setLoading(true);
    try {
      const res = await axios.post(api, {
        status: 'filterLogs',
        data: {
          date_from: dateFrom,
          date_to: dateTo,
          tech_id: selectedEmployee
        }
        
      }, {
        headers: { 'Content-Type': 'application/json' }
      });
      const data = Array.isArray(res.data[0]) ? res.data[0] : [];
      setLogs(data);
      setFilteredLogs(data);
      setRegTime(res.data[1] || 0);
      setOvertime(res.data[2] || 0);
    } catch (error) {
      toast.error('Filter failed', { position: 'top-center' });
    } finally {
      setLoading(false);
    }
  };
  
  const exportToCSV = () => {
    if (!filteredLogs.length) {
      toast.warning('No data to export.', { position: 'top-center' });
      return;
    }
  
    const quote = (val) => {
      if (val == null) return '""';
      const str = String(val).replace(/"/g, '""').replace(/(\r\n|\n|\r)/gm, ' ');
      return `"${str}"`;
    };
  
    // CSV header
    let csv = [
      [
        'ID',
        'Employee Name',
        'Date',
        'Time In',
        'Time Out',
        'Regular Hrs',
        'Overtime Hrs',
        'Type',
        'Contractor',
        'Job Status',
        'Address',
        'Notes',
        'Billable',
        'Additional Tech'
      ]
    ].map(row => row.join(',')).join('\n') + '\n';
  
    // CSV rows
    filteredLogs.forEach((log) => {
      const row = [
        log.id,
        quote(log.employee_name),
        quote(log.date),
        quote(log.time_in),
        quote(log.time_out),
        log.reg_hrs || 0,
        log.over_hrs || 0,
        quote(log.time_type_input),
        quote(log.contractor),
        quote(log.job_status),
        quote(log.address),
        quote(log.notes),
        log.billable === 1 ? 'Yes' : 'No',
        quote(log.additional_tech)
      ];
      csv += row.join(',') + '\n';
    });
  
    // Download trigger
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `tech_timesheet_export_${Date.now()}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleFilterByJobNumber = async () => {
    if (!jobNumber.trim()) {
      toast.warning('Enter a job number', { position: 'top-center' });
      return;
    }
  
    setLoading(true);
    try {
      const response = await axios.post(api, {
        status: 'filterByJobNumberAndDate',
        data: {
          job_number: jobNumber,
          date_from: jobDateFrom,
          date_to: jobDateTo
        }
      }, {
        headers: { 'Content-Type': 'application/json' }
      });
  
      const data = Array.isArray(response.data[0]) ? response.data[0] : [];
      setLogs(data);
      setFilteredLogs(data);
      setRegTime(response.data[1] || 0);
      setOvertime(response.data[2] || 0);
    } catch (error) {
      toast.error('Error filtering by job number and date range', { position: 'top-center' });
    } finally {
      setLoading(false);
    }
  };
  
  

  return (
    <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-8">
      <HeadingCp label="Technician Timesheet Report" />

      <>{/*codex-- Match the updated toolbar: grouped actions, labeled controls, and lighter original colors. */}
        <PageToolbar title="Timesheet report tools" actions={<>
          <button onClick={exportToCSV} className="bg-orange-600 hover:bg-orange-700 text-white px-4 py-2 rounded text-sm mb-4">Export to CSV</button>
        </>}>
          <ToolbarField label="From"><input type="date" className="border border-gray-300 rounded-md px-2 py-2" value={dateFrom} onChange={e => setDateFrom(e.target.value)} /></ToolbarField>
          <span className="text-gray-600">to</span>
          <ToolbarField label="To"><input type="date" className="border border-gray-300 rounded-md px-2 py-2" value={dateTo} onChange={e => setDateTo(e.target.value)} /></ToolbarField>
          <ToolbarField label="Employee"><select className="border border-gray-300 rounded-md px-6 py-2" value={selectedEmployee} onChange={e => setSelectedEmployee(e.target.value)}>
              <option value="">Select Employee</option>
              {employees.length > 0 ? employees.map(employee => <option key={employee.id} value={employee.id}>
                {employee.first_name}
                {employee.last_name}
              </option>) : <option value="" disabled>No employees found</option>}
            </select></ToolbarField>
          <button onClick={handleDateEmployeeFilter} className="bg-blue-500 hover:bg-blue-700 text-white text-sm px-4 py-2 rounded">Filter Tech</button>
          <ToolbarField label="Job number"><input type="text" placeholder="Job Number" value={jobNumber} onChange={e => setJobNumber(e.target.value)} className="border border-gray-300 rounded-md px-3 py-2 w-48" /></ToolbarField>
          <ToolbarField label="From"><input type="date" value={jobDateFrom} onChange={e => setJobDateFrom(e.target.value)} className="border border-gray-300 rounded-md px-2 py-2" /></ToolbarField>
          <span className="text-gray-600">to</span>
          <ToolbarField label="To"><input type="date" value={jobDateTo} onChange={e => setJobDateTo(e.target.value)} className="border border-gray-300 rounded-md px-2 py-2" /></ToolbarField>
          <button onClick={handleFilterByJobNumber} className="bg-blue-600 hover:bg-blue-700 text-white text-sm px-4 py-2 rounded">Filter Job #</button>
        </PageToolbar>
      </>


      <div className="flex space-x-3 items-center mb-2">
        <p className="text-sm text-gray-600">Overtime: {overtime}hrs</p>
        <p className="text-sm text-gray-600">Regular Time: {regTime}hrs</p>
        {/* <SearchBarCP search={searchTerm} handleChange={handleSearchChange} onClick={handleSearchClick} /> */}
      </div>

      {loading ? (
        <LoadingSpinner>Loading...</LoadingSpinner>
      ) : (
        <table className="min-w-full divide-y divide-gray-300 bg-gray-200 border rounded-lg text-xs sm:text-sm">
          <thead>
            <tr className="divide-x divide-gray-400">
              <th className="py-3.5 px-3 text-left font-semibold text-gray-900">Tech</th>
              <th className="px-3 py-3.5 text-left font-semibold text-gray-900">Date</th>
              <th className="px-3 py-3.5 text-left font-semibold text-gray-900">Time In</th>
              <th className="px-3 py-3.5 text-left font-semibold text-gray-900">Time Out</th>
              <th className="px-3 py-3.5 text-left font-semibold text-gray-900">RH</th>
              <th className="px-3 py-3.5 text-left font-semibold text-gray-900">OH</th>
              <th className="px-3 py-3.5 text-left font-semibold text-gray-900">Type</th>
              <th className="px-3 py-3.5 text-left font-semibold text-gray-900">Contractor</th>
              <th className="px-3 py-3.5 text-left font-semibold text-gray-900 hidden sm:table-cell">Job/Status</th>
              <th className="px-3 py-3.5 text-left font-semibold text-gray-900 hidden sm:table-cell">Address</th>
              <th className="px-3 py-3.5 text-left font-semibold text-gray-900">Notes</th>
            </tr>
          </thead>
          <tbody>
            {filteredLogs.map((log, index) => (
              <tr key={log.id} className={`${index % 2 === 0 ? 'bg-white' : 'bg-gray-100'} divide-x`}>
                <td className="px-3 py-2 text-gray-800">{log.employee_name}</td>
                <td className="px-3 py-2 text-gray-800">{<DateFormat date={log.date} />}</td>
                <td className="px-3 py-2 text-gray-800">{log.time_in}</td>
                <td className="px-3 py-2 text-gray-800">{log.time_out}</td>
                <td className="px-3 py-2 text-gray-800">{log.reg_hrs}</td>
                <td className="px-3 py-2 text-gray-800">{log.over_hrs || 0}</td>
                <td className="px-3 py-2 text-gray-800">{log.time_type_input}</td>
                <td className="px-3 py-2 text-gray-800">
                  {log.time_type_input === 'log' ? log.customer_service : log.contractor 
                                                 ? log.contractor 
                                                 : log.time_type_input === 'sai' 
                                                 ? log.customer_inspection : log.contractor}
                  {/* {log.contractor} */}
                </td>
                <td className="px-3 py-2 text-gray-800 hidden sm:table-cell">
                  <span>{log.job_status}</span> <br />
                  <span>{log.numberid}</span>
                </td>
                <td className="px-3 py-2 text-gray-800 hidden sm:table-cell">{log.address}</td>
                <td className="px-3 py-2 text-gray-600">{log.notes}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default TechTimesheetReport;
